import { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServices from "../../../services/RequestServies";
import * as XLSX from "xlsx";
import Swal from "sweetalert2"; // Import SweetAlert2
import axios from "axios";
import RequestServies from "../../../services/RequestServies";
import LocationServices from '../../../services/LocationServices';
import TransferTable from "./TransferTable";
import TransferRequestTable from "./TransferRequestTable";
import MIVTable from "./MIVTable";
import RVTable from "./RVTable";
import RepairMRVTable from "./RepairMRVTable";
import RequisitionTable from "./RequisitionTable";
import RepairRequestTable from "./RepairRequestTable";



const GenrateDigitalForm = () => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [formNumber, setFormNumber] = useState("");
  const [requestType, setRequestType] = useState("rv");
  const [store, setStore] = useState("all");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalcount, setTotalCount] = useState(0);
  const user = JSON.parse(localStorage.getItem('userDetails'));

  const availableStores =
    user?.data?.user?.store || [];

  // ✅ CHECK ROLE
  const isSuperAdmin =
    user?.data?.user?.role === "superAdmin";

  // ✅ DEFAULT STORE
  const defaultStore =
    availableStores[0]?._id || "";

  // ✅ STORE STATE
  const [stores, setStores] = useState([]);

  // ✅ SELECTED STORE
  const [selectedStore, setSelectedStore] =
    useState(defaultStore);


  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
  };
  const [data, setData] = useState({})

  // ✅ STORE LOAD LOGIC
  useEffect(() => {

    // ✅ SUPER ADMIN
    if (isSuperAdmin) {

      LocationServices.getStore()
        .then((response) => {

          const allStores =
            response?.data?.data || [];

          setStores(allStores);

          // ✅ DEFAULT SELECT
          if (allStores.length > 0) {
            setSelectedStore(
              allStores[0]?._id || ""
            );
          }

        })
        .catch((error) => {

          console.error(
            "Error fetching stores:",
            error
          );

        });

    }

    // ✅ NORMAL USER
    else {

      setStores(availableStores);

      setSelectedStore(
        availableStores[0]?._id || ""
      );

    }

  }, [isSuperAdmin]);

  const handleSearch = async () => {
    if (!formNumber) {
      Swal.fire("Error", "Please enter form number and select a store", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await RequestServies.getdocumetwithitems({
        no: formNumber,
        type: requestType,
        store: selectedStore,
      });
      setData(res);
      setReportData(res?.document?.items || []); // Use `res.items`, not `res.document`
      setTotalCount(res?.document?.items?.length || 0); // Count `items`, not `document`
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  const formatDateDMY = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`; // DD/MM/YYYY
  };

  const safeUpper = (value) =>
    typeof value === "string" ? value.toUpperCase() : "";


  const handlePrint = () => {

    const status = data?.document?.status;

    const isRequisition =
      requestType === "requisition";

    const isRepairRequest =
      requestType === "repair-request";

    const allowedRepairRequestStatuses = [
      "close",
      "PO Pending",
    ];

    const isRepairRequestPrintable =
      isRepairRequest &&
      allowedRepairRequestStatuses.includes(status);

    if (
      !isRequisition &&
      !isRepairRequestPrintable &&
      (!status || status !== "close")
    ) {
      Swal.fire({
        icon: "warning",
        title: "Print Not Allowed",
        text: `You cannot print this document because current status is "${status || "N/A"}".`,
      });

      return;
    }

    const printWindow = window.open("", "_blank");

    // rest of your existing code...
    if (!printWindow) {
      Swal.fire(
        "Popup Blocked",
        "Please allow popups to print the document.",
        "warning"
      );
      return;
    }

    const repairRequestDocument = data?.document || {};

    const repairRequestItems =
      Array.isArray(reportData) && reportData.length > 0
        ? reportData
        : Array.isArray(repairRequestDocument?.items)
          ? repairRequestDocument.items
          : [];

    /*
     * Approval information is available item-wise.
     * Find the first available approval record for each stage.
     */
    const repairAdminApproval = repairRequestItems.find(
      (item) => item?.approvedByAdmin?.name
    )?.approvedByAdmin;

    const repairCentralApproval = repairRequestItems.find(
      (item) => item?.approvedBySuperAdmin?.name
    )?.approvedBySuperAdmin;

    const repairHoApproval = repairRequestItems.find(
      (item) => item?.approvedByBoss?.name
    )?.approvedByBoss;

    const getRepairRequestStatus = (status) => {
      switch (status) {
        case "open":
          return "Open";

        case "submit":
          return "Pending With Project Manager";

        case "adminSubmit":
          return "Pending With Central Team";

        case "pendingWithBoss":
          return "Pending With HO";

        case "PO Pending":
          return "PO Pending";

        case "close":
          return "Closed";

        case "cancelled":
          return "Cancelled";

        default:
          return status || "N/A";
      }
    };

    const getRepairItemStatus = (status) => {
      switch (status) {
        case "approvedByAdmin":
          return "Approved By Project Manager";

        case "approvedBySuperAdmin":
          return "Approved By Central Team";

        case "approved":
          return "Approved";

        case "recived":
          return "Received";

        case "tranfer request":
          return "Transfer Request";

        case "forceclosed":
          return "Force Closed";

        case "autoclosed":
          return "Auto Closed";

        case "local":
          return "Local";

        case "rejected":
          return "Rejected";

        case "pending":
          return "Pending";

        default:
          return status || "N/A";
      }
    };

    const getRepairPoStatus = (poStatus) => {
      switch (poStatus) {
        case "pending":
          return "PO Pending";

        case "generated":
          return "PO Generated";

        case "pendingForApproval":
          return "Pending For Approval";

        case "waitingForBoss":
          return "Waiting For HO";

        default:
          return poStatus || "N/A";
      }
    };
    let htmlContent = `
    <html lang="en">
    <head>
      <meta charset="utf-8"/>
      <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <title>Material Transfer Note</title>
      <script src="https://cdn.tailwindcss.com"></script>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
        body { font-family: 'Roboto', sans-serif; padding: 2rem; }
        table { width: 100%; border-collapse: collapse; margin-top: 1rem; }
        th, td { border: 1px solid #000; padding: 0.5rem; text-align: left; }
        th { background-color: #f3f3f3; }
      </style>
    </head>
    <body>
      <div style="max-width: 64rem; margin: 0 auto; border: 1px solid #000; padding: 1rem;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; position: relative;">
          <div>
            <h1 style="font-size: 1.25rem; font-weight: bold;">Indigo Infraprojects Pvt. Ltd.</h1>
            <p style="font-size: 0.875rem;">
              3rd Floor, Plot No. - 12/B, Pocket 3, Sector – 17,<br/>
              Dwarka, New Delhi – 110 075<br/>
              Ph.: +91-11-4572 0141 / 4445 8664
            </p>
          </div>
          <p style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 1.1rem; font-weight: bold; color:black;">
            DIGITAL COPY
          </p>
          <div>
            <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" alt="Indigo Infraprojects Pvt. Ltd. logo" width="100" height="50"/>
          </div>
        </div>
        <h2 style="text-align: center; font-size: 1.125rem; font-weight: bold; margin-bottom: 1rem;">MATERIAL TRANSFER NOTE (MTN / CHALLAN)</h2>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem;">
          <div>
            <p>MTN No. <span style="font-weight: bold;">${data?.document?.mrvNo || ''}</span></p>
            <p>From Location:<strong> ${data?.document?.items[0]?.from?.toUpperCase() || ''}</strong></p>
            <p>Requested By:<strong> ${data?.document?.user?.name?.toUpperCase() || ''}</strong></p>
          </div>
          <div>
            <p>MTN Date:<strong> ${formatDateDMY(data?.document?.createdAt)}</strong></p>
            <p>To Location:<strong> ${data?.document?.items[0]?.to?.toUpperCase() || ''}</strong></p>
            <p>Status: <strong>${data?.document?.status?.toUpperCase() || ''}</strong></p>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Part No.</th>
              <th>Description</th>
              <th>Approved Qty</th>
              <th>Received Qty</th>
              <th>Damage Qty</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            ${data?.document?.items
        .map((item, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${item?.masterItem?.partNo || ''}</td>
                  <td>${item?.masterItem?.description || ''}</td>
                  <td>${item?.approveQty || 0} (${item?.masterItem?.unitName || ''})</td>
                  <td>${item?.recived || 0} (${item?.masterItem?.unitName || ''})</td>
                   <td>${item?.damageQty || 0} (${item?.masterItem?.unitName || ''})</td>
                  <td>${item?.status || ''}</td>
                </tr>
              `)
        .join('')}
          </tbody>
        </table>
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem; margin-top: 1rem;">
          <div>
            <p>Vehicle No.: ................................................</p>
            <p>Store Incharge: ................................................</p>
            <p>Date: ................................................</p>
          </div>
          <div>
            <p>Received By : <strong>${data?.document?.user?.name?.toUpperCase() || ''}</strong></p>
            <p>................................................</p>
            <p>Date: ................................................</p>
          </div>
          <div>
            <p>Verified & Accepted By :</p>
            <p>................................................</p>
            <p>Date: ................................................</p>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

    const loggedInUser =
      JSON.parse(
        localStorage.getItem("userDetails")
      );

    const currentRole =
      String(
        loggedInUser?.data?.user?.role || ""
      ).toLowerCase();


    // ==========================================
    // STOREKEEPER + ADMIN
    // CANNOT SEE COMMERCIAL DETAILS
    // ==========================================

    const hideCommercialDetails =
      [
        "storekeeper",
        "admin"
      ].includes(currentRole);


    let htmlMRvContent = `
<html lang="en">

<head>
    <meta charset="utf-8"/>
    <meta content="width=device-width, initial-scale=1.0" name="viewport"/>
    <title>Material Receipt Voucher</title>
</head>

<body style="background-color: #f7fafc; padding: 16px;">

<div style="max-width: 1024px; margin: 0 auto; background-color: white; padding: 24px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">

    <!-- HEADER -->

    <div style="margin-bottom:16px;">

        <!-- ROW 1: COMPANY (LEFT) + LOGO (RIGHT) -->

        <div style="display:flex; justify-content:space-between; align-items:flex-start;">

            <div>

                <h1 style="font-size:1.25rem; font-weight:bold; margin:0;">
                    Indigo Infraprojects Pvt. Ltd.
                </h1>

                <p style="font-size:0.875rem; margin:2px 0;">
                    3rd Floor, Plot No. - 12/B, Pocket 3, Sector - 17, Dwarka
                </p>

                <p style="font-size:0.875rem; margin:2px 0;">
                    New Delhi - 110 075
                </p>

            </div>


            <div style="text-align:right;">

                <img
                    src="https://indigoinfra.in/img/product/product-1739471679615.jpeg"
                    width="110"
                    height="55"
                    style="display:block;"
                />

            </div>

        </div>


        <!-- ROW 2: CENTERED TITLE -->

        <div style="text-align:center; margin-top:12px;">

            <h2 style="
                font-size:1.15rem;
                font-weight:bold;
                margin:0;
                letter-spacing:1px;
                text-transform:uppercase;
            ">
                Material Receipt Voucher(DIGITAL COPY)
            </h2>

        </div>

    </div>


    <!-- MRV HEADER DETAILS -->

    <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">

        <div>

            <p>
                MRV No. :
                <span style="font-weight: bold;">
                    ${data?.document?.mrvNo ?? "N/A"}
                </span>
            </p>

            <p>
                Supplier Name :
                ${data?.document?.supplierName
        ? data.document.supplierName.toUpperCase()
        : "N/A"
      }
            </p>

            <p>
                Bill No. / DC No. :
                ${data?.document?.billingNo ?? "N/A"}
            </p>

            <p>
                Bill Date :
                ${data?.document?.billingDate
        ? formatDateDMY(data.document.billingDate)
        : "N/A"
      }
            </p>

            <p>
                Status:
                <strong>
                    ${data?.document?.status
        ? data.document.status.toUpperCase()
        : "N/A"
      }
                </strong>
            </p>

        </div>


        <div>

            <p>
                Project Code :
                ${data?.document?.storeCode ?? "N/A"}
            </p>

            <p>
                Project Name :
                ${data?.document?.storeName
        ? data.document.storeName.toUpperCase()
        : "N/A"
      }
            </p>

            <p>
                Location :
                <strong>
                    ${data?.document?.storeName
        ? data.document.storeName.toUpperCase()
        : "N/A"
      }
                </strong>
            </p>

            <p>
                Date:
                <strong>
                    ${data?.document?.createdAt
        ? formatDateDMY(data.document.createdAt)
        : "N/A"
      }
                </strong>
            </p>

        </div>

    </div>

<!-- TABLE -->

<table
  style="
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #cbd5e0;
    margin-bottom: 16px;
    font-size: 11px;
    line-height: 1.35;
    text-align: left;
  "
>
  <thead>
    <tr>

      <!-- S.NO -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        S.No
      </th>


      <!-- PART NO -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        Part No
      </th>


      <!-- DESCRIPTION -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        Description
      </th>


      <!-- UNIT -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        Unit
      </th>


      <!-- REQUIRED QTY -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        Req Qty
      </th>


      <!-- APPROVED QTY -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        Appr Qty
      </th>


      <!-- RECEIVED QTY -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        Received Qty
      </th>


      <!-- DAMAGE QTY -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        Damage Qty
      </th>


      <!-- PO -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        PO
      </th>


      <!-- STATUS -->
      <th
        style="
          border: 1px solid #cbd5e0;
          padding: 8px;
          font-weight: 700;
        "
      >
        Status
      </th>

    </tr>
  </thead>


  <tbody>

    ${reportData.map((item, index) => {

      const partNo =
        item?.partNo ||
        item?.inventoryPartNo ||
        item?.masterItem?.partNo ||
        "N/A";


      const description =
        item?.description ||
        item?.inventoryDescription ||
        item?.masterItem?.description ||
        "N/A";


      const unit =
        item?.unitName ||
        item?.masterItem?.unitName ||
        item?.poDetails?.unit ||
        "N/A";


      const requiredQty =
        item?.qtyRequired ?? 0;


      const approvedQty =
        item?.approveQty ?? 0;


      const receivedQty =
        item?.qtyRecived ?? 0;


      const damageQty =
        item?.damageQty ?? 0;


      const poNumber =
        item?.poDetails?.poNumber ||
        item?.poNumber ||
        "N/A";


      const status =
        item?.status === "recived"
          ? "received"
          : item?.status || "N/A";


      return `

        <tr>

          <!-- S.NO -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
            "
          >
            ${index + 1}
          </td>


          <!-- PART NO -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
              white-space: nowrap;
            "
          >
            ${partNo}
          </td>


          <!-- DESCRIPTION -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
            "
          >
            ${description}
          </td>


          <!-- UNIT -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
              white-space: nowrap;
            "
          >
            ${unit}
          </td>


          <!-- REQUIRED QTY -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
            "
          >
            ${requiredQty}
          </td>


          <!-- APPROVED QTY -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
            "
          >
            ${approvedQty}
          </td>


          <!-- RECEIVED QTY -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
            "
          >
            ${receivedQty}
          </td>


          <!-- DAMAGE QTY -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
            "
          >
            ${damageQty}
          </td>


          <!-- PO -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
              white-space: nowrap;
            "
          >
            ${poNumber}
          </td>


          <!-- STATUS -->
          <td
            style="
              border: 1px solid #cbd5e0;
              padding: 8px;
              white-space: nowrap;
            "
          >
            ${status}
          </td>

        </tr>

      `;

    }).join("")}

  </tbody>

</table>
  <!-- FOOTER -->

    <div style="margin-top:32px; font-size:14px;">

        <!-- SINGLE ROW : LEFT | CENTER | RIGHT -->

        <div style="display:flex; justify-content:space-between; align-items:flex-start;">


            <!-- LEFT : PREPARED BY (STORE KEEPER) -->

            <div style="width:33%; text-align:left;">

                <div>

                    Prepared&nbsp;By&nbsp;:&nbsp;

                    <strong>

                        ${data?.document?.userName
        ? data.document.userName.toUpperCase()
        : "__________"
      }

                    </strong>

                </div>


                <div style="margin-top:4px;">

                    (Store&nbsp;Keeper)

                </div>


                <div style="margin-top:4px;">

                    Date&nbsp;:&nbsp;

                    <strong>

                        ${data?.document?.createdAt
        ? formatDateDMY(
          data.document.createdAt
        )
        : "__________"
      }

                    </strong>

                </div>

            </div>


            <!-- CENTER : PROJECT MANAGER -->

            <div style="width:33%; text-align:center;">

                <div>

                    Approved&nbsp;By&nbsp;:&nbsp;

                    <strong>

                        ${data?.document?.approvedByAdmin?.name
        ? data.document.approvedByAdmin.name.toUpperCase()
        : "__________"
      }

                    </strong>

                </div>


                <div style="margin-top:4px;">

                    (Project&nbsp;Manager)

                </div>


                <div style="margin-top:4px;">

                    Date&nbsp;:&nbsp;

                    <strong>

                        ${data?.document?.approvedByAdmin?.approvedAt
        ? formatDateDMY(
          data.document.approvedByAdmin.approvedAt
        )
        : "__________"
      }

                    </strong>

                </div>

            </div>


            <!-- RIGHT : CENTRAL TEAM -->

            <div style="width:33%; text-align:right;">

                <div>

                    Approved&nbsp;By&nbsp;:&nbsp;

                    <strong>

                        ${data?.document?.approvedBySuperAdmin?.name
        ? data.document.approvedBySuperAdmin.name.toUpperCase()
        : "__________"
      }

                    </strong>

                </div>


                <div style="margin-top:4px;">

                    (Central&nbsp;Team)

                </div>


                <div style="margin-top:4px;">

                    Date&nbsp;:&nbsp;

                    <strong>

                        ${data?.document?.approvedBySuperAdmin?.approvedAt
        ? formatDateDMY(
          data.document.approvedBySuperAdmin.approvedAt
        )
        : "__________"
      }

                    </strong>

                </div>

            </div>

        </div>

    </div>

</div>

</body>

</html>
`;

    let htmlRepairMRVContent = `
<html lang="en">
<head>
  <meta charset="utf-8"/>
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Repair Material Receipt Voucher</title>
</head>
<body style="background-color: #f7fafc; padding: 16px;">
  <div style="max-width: 1024px; margin: 0 auto; background-color: white; padding: 24px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
    
   <!-- HEADER -->
<div style="margin-bottom:16px;">

  <!-- ROW 1: COMPANY (LEFT) + LOGO (RIGHT) -->
  <div style="display:flex; justify-content:space-between; align-items:flex-start;">
    <div>
      <h1 style="font-size:1.25rem; font-weight:bold; margin:0;">
        Indigo Infraprojects Pvt. Ltd.
      </h1>
      <p style="font-size:0.875rem; margin:2px 0;">
        3rd Floor, Plot No. - 12/B, Pocket 3, Sector - 17, Dwarka
      </p>
      <p style="font-size:0.875rem; margin:2px 0;">
        New Delhi - 110 075
      </p>
    </div>

    <div style="text-align:right;">
      <img
        src="https://indigoinfra.in/img/product/product-1739471679615.jpeg"
        width="110"
        height="55"
        style="display:block;"
      />
    </div>
  </div>

  <!-- ROW 2: CENTERED TITLE -->
  <div style="text-align:center; margin-top:12px;">
    <h2 style="
      font-size:1.15rem;
      font-weight:bold;
      margin:0;
      letter-spacing:1px;
      text-transform:uppercase;
    ">
      Repair Material Receipt Voucher(DIGITAL COPY)
    </h2>
  </div>

</div>


    <!-- DETAILS -->
    <div style="display:flex; justify-content:space-between; margin-bottom:16px;">
      <div>
        <p><strong>Repair MRV No:</strong> ${data?.document?.repairMrvNo}</p>
        <p><strong>Supplier:</strong> ${data?.document?.supplierName}</p>
        <p><strong>Bill No:</strong> ${data?.document?.billingNo}</p>
        <p><strong>Bill Date:</strong> ${formatDateDMY(data?.document?.billingDate)}</p>
      </div>
      <div>
        <p><strong>Store Code:</strong> ${data?.document?.storeCode}</p>
        <p><strong>Store Name:</strong> ${data?.document?.storeName}</p>
        <p><strong>Status:</strong> ${data?.document?.status?.toUpperCase()}</p>
        <p><strong>Date:</strong> ${formatDateDMY(data?.document?.createdAt)}</p>
      </div>
    </div>

    <!-- TABLE -->
    <table style="width:100%; border-collapse:collapse; border:1px solid #cbd5e0;">
      <thead>
        <tr>
          <th style="border:1px solid #cbd5e0; padding:8px;">S.No</th>
          <th style="border:1px solid #cbd5e0; padding:8px;">Inventory Item</th>
          <th style="border:1px solid #cbd5e0; padding:8px;">Repair Item</th>
          <th style="border:1px solid #cbd5e0; padding:8px;">Unit</th>
          <th style="border:1px solid #cbd5e0; padding:8px;">Req Qty</th>
          <th style="border:1px solid #cbd5e0; padding:8px;">Appr Qty</th>
          <th style="border:1px solid #cbd5e0; padding:8px;">Recv Qty</th>
          <th style="border:1px solid #cbd5e0; padding:8px;">Status</th>
          <th style="border:1px solid #cbd5e0; padding:8px;">Updated</th>
        </tr>
      </thead>
      <tbody>
        ${reportData.map((item, index) => `
          <tr>
            <td style="border:1px solid #cbd5e0; padding:8px;">${index + 1}</td>
            <td style="border:1px solid #cbd5e0; padding:8px;">
              ${item.inventoryPartNo} - ${item.inventoryDescription}
            </td>
            <td style="border:1px solid #cbd5e0; padding:8px;">
              ${item.masterlistPartNo} - ${item.masterlistDescription}
            </td>
            <td style="border:1px solid #cbd5e0; padding:8px;">
              ${item.masterlistUnit}
            </td>
            <td style="border:1px solid #cbd5e0; padding:8px;">${item.qtyRequired}</td>
            <td style="border:1px solid #cbd5e0; padding:8px;">${item.approveQty}</td>
            <td style="border:1px solid #cbd5e0; padding:8px;">${item.qtyRecived}</td>
            <td style="border:1px solid #cbd5e0; padding:8px;">${item.status}</td>
            <td style="border:1px solid #cbd5e0; padding:8px;">
              ${formatDateDMY(item.updatedAt)}
            </td>
          </tr>
        `).join("")}
      </tbody>
    </table>

<!-- FOOTER -->
<div style="margin-top:36px; font-size:14px;">

  <div style="
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    text-align:center;
  ">

    <!-- LEFT : STORE KEEPER -->
    <div style="width:33%; text-align:left; line-height:1.6;">
      <div style="margin-bottom:6px;"><strong>Prepared By</strong></div>

      <div style="margin-bottom:6px;">
        ${safeUpper(data?.document?.userName) || "___________"}
      </div>

      <div style="margin-bottom:6px; font-size:12px;">
        (Store Keeper)
      </div>

      <div>
        <strong>Date:</strong>
        ${data?.document?.createdAt
        ? formatDateDMY(data.document.createdAt)
        : "___________"}
      </div>
    </div>

    <!-- CENTER : PROJECT MANAGER -->
    <div style="width:33%; line-height:1.6;">
      <div style="margin-bottom:6px;"><strong>Approved By</strong></div>

      <div style="margin-bottom:6px;">
        ${data?.document?.approvedByAdmin?.name
        ? safeUpper(data.document.approvedByAdmin.name)
        : "___________"}
      </div>

      <div style="margin-bottom:6px; font-size:12px;">
        (Project Manager)
      </div>

      <div>
        <strong>Date:</strong>
        ${data?.document?.approvedByAdmin?.approvedAt
        ? formatDateDMY(data.document.approvedByAdmin.approvedAt)
        : "___________"}
      </div>
    </div>

    <!-- RIGHT : CENTRAL TEAM -->
    <div style="width:33%; text-align:right; line-height:1.6;">
      <div style="margin-bottom:6px;"><strong>Approved By</strong></div>

      <div style="margin-bottom:6px;">
        ${data?.document?.approvedBySuperAdmin?.name
        ? safeUpper(data.document.approvedBySuperAdmin.name)
        : "___________"}
      </div>

      <div style="margin-bottom:6px; font-size:12px;">
        (Central Team)
      </div>

      <div>
        <strong>Date:</strong>
        ${data?.document?.approvedBySuperAdmin?.approvedAt
        ? formatDateDMY(data.document.approvedBySuperAdmin.approvedAt)
        : "___________"}
      </div>
    </div>

  </div>
</div>


</body>
</html>
`;

    let htmlRepairRequestContent = `
<html lang="en">
<head>
  <meta charset="utf-8"/>
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0"
  />

  <title>Repair Request</title>

  <style>
    * {
      box-sizing: border-box;
    }

    body {
      margin: 0;
      padding: 16px;
      background-color: #f7fafc;
      font-family: Arial, Helvetica, sans-serif;
      color: #000;
      font-size: 13px;
    }

    .print-container {
      max-width: 1100px;
      margin: 0 auto;
      padding: 24px;
      background-color: #ffffff;
      border: 1px solid #cbd5e0;
    }

    .header-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .company-name {
      margin: 0;
      font-size: 20px;
      font-weight: bold;
    }

    .company-address {
      margin: 3px 0;
      font-size: 13px;
      line-height: 1.4;
    }

    .document-title {
      margin-top: 14px;
      text-align: center;
    }

    .document-title h2 {
      margin: 0;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
      text-transform: uppercase;
    }

    .details-section {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 18px;
      gap: 30px;
    }

    .details-column {
      width: 50%;
    }

    .details-column p {
      margin: 7px 0;
    }

    .details-column-right {
      text-align: right;
    }

    .label {
      font-weight: bold;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: auto;
    }

    th,
    td {
      border: 1px solid #718096;
      padding: 7px;
      vertical-align: top;
      word-break: break-word;
    }

    th {
      background-color: #edf2f7;
      font-weight: bold;
      text-align: center;
    }

    td {
      text-align: left;
    }

    .text-center {
      text-align: center;
    }

    .approval-section {
      margin-top: 40px;
      page-break-inside: avoid;
    }

    .approval-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .approval-column {
      width: 25%;
      line-height: 1.6;
    }

    .approval-left {
      text-align: left;
    }

    .approval-center {
      text-align: center;
    }

    .approval-right {
      text-align: right;
    }

    .approval-heading {
      margin-bottom: 6px;
      font-weight: bold;
    }

    .approval-role {
      margin-top: 4px;
      font-size: 12px;
    }

    .approval-date {
      margin-top: 5px;
    }

    @media print {
      @page {
        size: landscape;
        margin: 10mm;
      }

      body {
        padding: 0;
        background-color: white;
        font-size: 11px;
      }

      .print-container {
        max-width: none;
        border: none;
        padding: 0;
      }

      th,
      td {
        padding: 5px;
      }

      thead {
        display: table-header-group;
      }

      tr {
        page-break-inside: avoid;
      }
    }
  </style>
</head>

<body>
  <div class="print-container">

    <!-- HEADER -->
    <div class="header-row">
      <div>
        <h1 class="company-name">
          Indigo Infraprojects Pvt. Ltd.
        </h1>

        <p class="company-address">
          3rd Floor, Plot No. - 12/B, Pocket 3,
          Sector - 17, Dwarka
        </p>

        <p class="company-address">
          New Delhi - 110 075
        </p>

        <p class="company-address">
          Ph.: +91-11-4572 0141 / 4445 8664
        </p>
      </div>

      <div style="text-align:right;">
        <img
          src="https://indigoinfra.in/img/product/product-1739471679615.jpeg"
          alt="Indigo Infraprojects Pvt. Ltd."
          width="110"
          height="55"
          style="display:block;"
        />
      </div>
    </div>

    <!-- TITLE -->
    <div class="document-title">
      <h2>
        Repair Request (Digital Copy)
      </h2>
    </div>

    <!-- REQUEST DETAILS -->
    <div class="details-section">

      <div class="details-column">
        <p>
          <span class="label">Repair Order No:</span>
          ${repairRequestDocument?.repairOrderNo ??
      "N/A"
      }
        </p>

        <p>
          <span class="label">Requested By:</span>
          ${safeUpper(
        repairRequestDocument?.user?.name
      ) || "N/A"
      }
        </p>

        <p>
          <span class="label">User Role:</span>
          ${repairRequestDocument?.user?.role ||
      "N/A"
      }
        </p>

        <p>
          <span class="label">Status:</span>
          ${getRepairRequestStatus(
        repairRequestDocument?.status
      )}
        </p>
      </div>

      <div class="details-column details-column-right">
        <p>
          <span class="label">Project Code:</span>
          ${repairRequestDocument?.store
        ?.storeCode || "N/A"
      }
        </p>

        <p>
          <span class="label">Project Name:</span>
          ${safeUpper(
        repairRequestDocument?.store?.name
      ) || "N/A"
      }
        </p>

        <p>
          <span class="label">Location:</span>
          ${safeUpper(
        repairRequestDocument?.store
          ?.location
      ) || "N/A"
      }
        </p>

        <p>
          <span class="label">Request Date:</span>
          ${formatDateDMY(
        repairRequestDocument?.createdAt
      )}
        </p>
      </div>

    </div>

    <!-- ITEM TABLE -->
    <table>
      <thead>
        <tr>
          <th style="width:4%;">S.No</th>

          <th style="width:8%;">
            Inventory Part No
          </th>

          <th style="width:15%;">
            Inventory Description
          </th>

          <th style="width:7%;">
            Repair Part No
          </th>

          <th style="width:15%;">
            Repair Description
          </th>

          <th style="width:6%;">Unit</th>

          <th style="width:6%;">
            Required Qty
          </th>

          <th style="width:6%;">
            Approved Qty
          </th>

          <th style="width:6%;">
            Received Qty
          </th>

          <th style="width:6%;">
            Damage Qty
          </th>

          <th style="width:9%;">
            Item Status
          </th>

          <th style="width:8%;">
            PO Status
          </th>

          <th style="width:8%;">
            Remark
          </th>
        </tr>
      </thead>

      <tbody>
        ${repairRequestItems.length > 0
        ? repairRequestItems
          .map(
            (item, index) => `
          <tr>
            <td class="text-center">
              ${index + 1}
            </td>

            <td>
              ${item?.inventoryPartNo ||
              "N/A"
              }
            </td>

            <td>
              ${item?.inventoryDescription ||
              "N/A"
              }
            </td>

            <td>
              ${item?.masterlistPartNo ||
              item?.partNo ||
              "N/A"
              }
            </td>

            <td>
              ${item?.masterlistDescription ||
              item?.description ||
              "N/A"
              }
            </td>

            <td class="text-center">
              ${item?.masterlistUnit ||
              item?.unit ||
              item?.inventoryUnit ||
              "N/A"
              }
            </td>

            <td class="text-center">
              ${item?.qtyRequired ?? 0}
            </td>

            <td class="text-center">
              ${item?.approveQty ?? 0}
            </td>

            <td class="text-center">
              ${item?.qtyReceived ??
              item?.qtyRecived ??
              0
              }
            </td>

            <td class="text-center">
              ${item?.damageQty ?? 0}
            </td>

            <td>
              ${getRepairItemStatus(
                item?.status
              )}
            </td>

            <td>
              ${getRepairPoStatus(
                item?.poStatus
              )}
            </td>

            <td>
              ${item?.remark ||
              item?.adminRemark ||
              "N/A"
              }
            </td>
          </tr>
        `
          )
          .join("")
        : `
          <tr>
            <td
              colspan="13"
              class="text-center"
            >
              No Repair Request Items Found.
            </td>
          </tr>
        `
      }
      </tbody>
    </table>

    <!-- APPROVAL FOOTER -->
    <div class="approval-section">
      <div class="approval-row">

        <!-- STORE KEEPER -->
        <div class="approval-column approval-left">
          <div class="approval-heading">
            Prepared By
          </div>

          <div>
            ${safeUpper(
        repairRequestDocument?.user?.name
      ) || "___________"
      }
          </div>

          <div class="approval-role">
            (Store Keeper)
          </div>

          <div class="approval-date">
            <strong>Date:</strong>
            ${repairRequestDocument?.createdAt
        ? formatDateDMY(
          repairRequestDocument.createdAt
        )
        : "___________"
      }
          </div>
        </div>

        <!-- PROJECT MANAGER -->
        <div class="approval-column approval-center">
          <div class="approval-heading">
            Approved By
          </div>

          <div>
            ${repairAdminApproval?.name
        ? safeUpper(
          repairAdminApproval.name
        )
        : "___________"
      }
          </div>

          <div class="approval-role">
            (Project Manager)
          </div>

          <div class="approval-date">
            <strong>Date:</strong>
            ${repairAdminApproval?.approvedAt
        ? formatDateDMY(
          repairAdminApproval.approvedAt
        )
        : "___________"
      }
          </div>
        </div>

        <!-- CENTRAL TEAM -->
        <div class="approval-column approval-center">
          <div class="approval-heading">
            Approved By
          </div>

          <div>
            ${repairCentralApproval?.name
        ? safeUpper(
          repairCentralApproval.name
        )
        : "___________"
      }
          </div>

          <div class="approval-role">
            (Central Team)
          </div>

          <div class="approval-date">
            <strong>Date:</strong>
            ${repairCentralApproval?.approvedAt
        ? formatDateDMY(
          repairCentralApproval.approvedAt
        )
        : "___________"
      }
          </div>
        </div>

        <!-- HO -->
        <div class="approval-column approval-right">
          <div class="approval-heading">
            Approved By
          </div>

          <div>
            ${repairHoApproval?.name
        ? safeUpper(
          repairHoApproval.name
        )
        : "___________"
      }
          </div>

          <div class="approval-role">
            (HO)
          </div>

          <div class="approval-date">
            <strong>Date:</strong>
            ${repairHoApproval?.approvedAt
        ? formatDateDMY(
          repairHoApproval.approvedAt
        )
        : "___________"
      }
          </div>
        </div>

      </div>
    </div>

  </div>
</body>
</html>
`;

    let htmlRequisitionContent = `
<html lang="en">
<head>
<meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
<title>Requisition</title>
</head>

<body style="background-color:#f7fafc; padding:16px;">
<div style="max-width:1024px; margin:0 auto; background:white; padding:24px; box-shadow:0 4px 6px rgba(0,0,0,0.1);">

<!-- HEADER -->
<div style="margin-bottom:16px;">
  <div style="display:flex; justify-content:space-between;">
    <div>
      <h1 style="font-size:1.25rem; font-weight:bold;">Indigo Infraprojects Pvt. Ltd.</h1>
      <p style="font-size:0.875rem;">Dwarka, New Delhi - 110075</p>
    </div>
    <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" width="110"/>
  </div>

  <div style="text-align:center; margin-top:10px;">
    <h2 style="font-weight:bold; text-transform:uppercase;">
      Requisition (Digital Copy)
    </h2>
  </div>
</div>

<!-- STATUS MAPPING -->
${(() => {
        const rawStatus = data?.document?.status;

        let statusText = rawStatus;

        if (rawStatus === "pendingWithBoss") statusText = "Pending With HO";
        else if (rawStatus === "pendingWithSuperAdmin") statusText = "Pending With Central Team";
        else if (rawStatus === "submit") statusText = "Pending With Project Manager";

        return `
  <div style="display:flex; justify-content:space-between; margin-bottom:16px;">
    <div>
      <p>Req No : <strong>${data?.document?.requisitionNo}</strong></p>
      <p>Requested By : ${data?.document?.user?.name?.toUpperCase()}</p>
      <p>Status : <strong>${statusText}</strong></p>
    </div>

    <div>
      <p>Project Code : ${data?.document?.storeCode}</p>
      <p>Project Name : ${data?.document?.storeName?.toUpperCase()}</p>
      <p>Date : <strong>${formatDateDMY(data?.document?.createdAt)}</strong></p>
    </div>
  </div>
  `;
      })()}

<!-- TABLE -->
<table style="width:100%; border-collapse:collapse; border:1px solid #cbd5e0;">
<thead>
<tr>
  <th style="border:1px solid #cbd5e0; padding:8px;">S.No</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Part No</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Description</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Unit</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Req Qty</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Appr Qty</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Mode / PO No</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Status</th>
</tr>
</thead>

<tbody>
${reportData.map((item, index) => {

        let itemStatus = item.status;

        if (item.status === "approvedBySuperAdmin") {
          itemStatus = "Approved By Central Team";
        } else if (item.status === "approvedByAdmin") {
          itemStatus = "Approved By Project Manager";
        }

        return `
<tr>
  <td style="border:1px solid #cbd5e0; padding:8px;">${index + 1}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.partNo}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.description}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.unitName}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.qtyRequired}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item.approveQty}</td>

  <td style="border:1px solid #cbd5e0; padding:8px;">
    ${item.poNumber ? item.poNumber : "LOCAL"}
  </td>

  <td style="border:1px solid #cbd5e0; padding:8px;">${itemStatus}</td>
</tr>
`;
      }).join("")}
</tbody>
</table>

<!-- FOOTER -->
<div style="margin-top:32px;">
  <div style="display:flex; justify-content:space-between;">

    <div style="width:33%;">
      <p>Prepared By</p>
      <strong>${data?.document?.user?.name?.toUpperCase()}</strong>
      <p>Date : ${formatDateDMY(data?.document?.createdAt)}</p>
    </div>

    <div style="width:33%; text-align:center;">
      <p>Admin Approval</p>
      <strong>${reportData[0]?.approvedByAdmin?.name || "________"}</strong>
      <p>${reportData[0]?.adminApprovedAt ? formatDateDMY(reportData[0].adminApprovedAt) : ""}</p>
    </div>

    <div style="width:33%; text-align:right;">
      <p>Super Admin</p>
      <strong>${reportData[0]?.approvedBySuperAdmin?.name || "________"}</strong>
      <p>${reportData[0]?.superAdminApprovedAt ? formatDateDMY(reportData[0].superAdminApprovedAt) : ""}</p>
    </div>

  </div>
</div>

</div>
</body>
</html>
`;

    const approvedByName =
      [...new Set(reportData.map(i => i.approvedBy).filter(Boolean))].join(", ") || "NA";

    const approvedDate =
      data?.document?.updatedAt
        ? formatDateDMY(data.document.updatedAt)
        : "NA";

    let htmlContentForMIV = `
<html lang="en">
<head>
  <meta charset="utf-8"/>
  <meta
    content="width=device-width, initial-scale=1.0"
    name="viewport"
  />

  <title>Material Issues Voucher</title>

  <script src="https://cdn.tailwindcss.com"></script>
</head>

<body
  style="
    background-color:#f3f4f6;
    padding:1rem;
    font-family:Arial, sans-serif;
  "
>
  <div
    style="
      max-width:64rem;
      margin:0 auto;
      background-color:white;
      padding:1.5rem;
      border:1px solid #d1d5db;
    "
  >

    <!-- HEADER -->
    <div
      style="
        display:flex;
        justify-content:space-between;
        align-items:center;
        margin-bottom:1rem;
      "
    >
      <div>
        <h1
          style="
            font-size:1.25rem;
            font-weight:bold;
          "
        >
          Indigo Infraprojects Pvt. Ltd.
        </h1>

        <p>
          3rd Floor, Plot No. - 12/B, Pocket 3,
          Sector – 17, Dwarka
        </p>

        <p>New Delhi – 110 075</p>

        <p>
          Ph : +91-11-4572 0741, 4445 8664
        </p>
      </div>

      <div>
        <img
          src="https://indigoinfra.in/img/product/product-1739471679615.jpeg"
          alt="Company Logo"
          style="height:3rem;"
        />
      </div>
    </div>

    <!-- TITLE -->
    <h2
      style="
        text-align:center;
        font-size:1.125rem;
        font-weight:bold;
        margin-bottom:1rem;
      "
    >
      MATERIAL ISSUES VOUCHER (DIGITAL COPY)
    </h2>

    <!-- DOCUMENT DETAILS -->
    <div
      style="
        display:grid;
        grid-template-columns:1fr 1fr;
        gap:1rem;
        margin-bottom:1rem;
      "
    >
      <div>
        <p>
          MIV No. :
          <strong>
            ${data?.document?.mivNo || "N/A"}
          </strong>
        </p>

        <p>
          Machine :
          <strong></strong>
        </p>

        <p>
          MIV Date :
          <strong>
            ${data?.document?.createdAt
        ? formatDateDMY(
          data.document.createdAt
        )
        : "N/A"
      }
          </strong>
        </p>

        <p>
          Request By :
          <strong>
            ${safeUpper(
        typeof data?.document?.user ===
          "string"
          ? data.document.user
          : data?.document?.userName ||
          data?.document?.user?.name
      ) || "N/A"
      }
          </strong>
        </p>

        <p>
          Status :
          <strong>
            ${data?.document?.status ===
        "submit"
        ? "Pending With Project Manager"
        : data?.document?.status ===
          "approved"
          ? "Closed"
          : data?.document?.status ||
          "-"
      }
          </strong>
        </p>
      </div>

      <div style="text-align:right;">
        <p>
          Project Code :
          <strong>
            ${data?.document?.storeCode ||
      data?.document?.store
        ?.storeCode ||
      "N/A"
      }
          </strong>
        </p>

        <p>
          Project Name :
          <strong>
            ${safeUpper(
        typeof data?.document?.store ===
          "string"
          ? data.document.store
          : data?.document?.storeName ||
          data?.document?.store?.name
      ) || "N/A"
      }
          </strong>
        </p>

        <p>
          Location :
          <strong>
            ${safeUpper(
        data?.document
          ?.storeLocation ||
        data?.document?.store
          ?.location
      ) || "N/A"
      }
          </strong>
        </p>

        <p>
          Closed Date :
          <strong>
            ${data?.document?.updatedAt
        ? formatDateDMY(
          data.document.updatedAt
        )
        : "N/A"
      }
          </strong>
        </p>
      </div>
    </div>

    <!-- TABLE -->
    <div style="margin-bottom:1rem;"></div>

    <table
      style="
        width:100%;
        border-collapse:collapse;
        border:1px solid #d1d5db;
        margin-bottom:1rem;
      "
    >
      <thead>
        <tr>
          <th
            style="
              border:1px solid #d1d5db;
              padding:0.5rem;
            "
          >
            S.No.
          </th>

          <th
            style="
              border:1px solid #d1d5db;
              padding:0.5rem;
            "
          >
            Part No
          </th>

          <th
            style="
              border:1px solid #d1d5db;
              padding:0.5rem;
            "
          >
            Description
          </th>

          <th
            style="
              border:1px solid #d1d5db;
              padding:0.5rem;
            "
          >
            Approved Qty
          </th>

          <th
            style="
              border:1px solid #d1d5db;
              padding:0.5rem;
            "
          >
            Used Qty.
          </th>

          <th
            style="
              border:1px solid #d1d5db;
              padding:0.5rem;
            "
          >
            Status
          </th>

          <th
            style="
              border:1px solid #d1d5db;
              padding:0.5rem;
            "
          >
            Store Remark
          </th>
        </tr>
      </thead>

      <tbody>
        ${Array.isArray(reportData) &&
        reportData.length > 0
        ? reportData
          .map(
            (item, index) => `
          <tr>
            <td
              style="
                border:1px solid #cbd5e0;
                padding:8px;
                height:32px;
              "
            >
              ${index + 1}
            </td>

            <td
              style="
                border:1px solid #cbd5e0;
                padding:8px;
              "
            >
              ${item?.partNo || "N/A"}
            </td>

            <td
              style="
                border:1px solid #cbd5e0;
                padding:8px;
              "
            >
              ${item?.description || "N/A"}
            </td>

            <td
              style="
                border:1px solid #cbd5e0;
                padding:8px;
              "
            >
              ${item?.approveQty ?? 0}
            </td>

            <td
              style="
                border:1px solid #cbd5e0;
                padding:8px;
              "
            >
              ${item?.usedQty ?? 0}
            </td>

            <td
              style="
                border:1px solid #cbd5e0;
                padding:8px;
              "
            >
              ${item?.status === "approved"
                ? "Close"
                : item?.status ===
                  "pending"
                  ? "Pending With Project Manager"
                  : item?.status || "-"
              }
            </td>

            <td
              style="
                border:1px solid #cbd5e0;
                padding:8px;
              "
            >
              ${item?.remark || "NA"}
            </td>
          </tr>
        `
          )
          .join("")
        : `
          <tr>
            <td
              colspan="7"
              style="
                border:1px solid #cbd5e0;
                padding:8px;
                text-align:center;
              "
            >
              No MIV Items Found.
            </td>
          </tr>
        `
      }
      </tbody>
    </table>

    <!-- FOOTER -->
    <div
      style="
        display:flex;
        justify-content:space-between;
        margin-top:1rem;
      "
    >
      <div style="text-align:center;">
        <p style="margin-bottom:2px;">
          ${approvedByName || "NA"}
        </p>

        <p
          style="
            margin-bottom:6px;
            font-size:12px;
          "
        >
          ${approvedDate || "NA"}
        </p>

        <p
          style="
            border-top:1px solid black;
            display:inline-block;
            width:8rem;
          "
        >
          Approved By
        </p>
      </div>

      <div style="text-align:center;">
        <p
          style="
            border-top:1px solid black;
            display:inline-block;
            width:8rem;
          "
        >
          Stores Officer
        </p>
      </div>

      <div style="text-align:center;">
        <p
          style="
            border-top:1px solid black;
            display:inline-block;
            width:8rem;
          "
        >
          Received By
        </p>
      </div>
    </div>

  </div>
</body>
</html>
`;
    let htmlTRanferRequestContent = `
    <html lang="en">
    <head>
      <meta charset="utf-8"/>
      <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <title>Material Transfer Request</title>
      <script src="https://cdn.tailwindcss.com"></script>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
        body { font-family: 'Roboto', sans-serif; padding: 2rem; }
        table { width: 100%; border-collapse: collapse; margin-top: 1rem; }
        th, td { border: 1px solid #000; padding: 0.5rem; text-align: left; }
        th { background-color: #f3f3f3; }
      </style>
    </head>
    <body>
      <div style="max-width: 64rem; margin: 0 auto; border: 1px solid #000; padding: 1rem;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; position: relative;">
          <div>
            <h1 style="font-size: 1.25rem; font-weight: bold;">Indigo Infraprojects Pvt. Ltd.</h1>
            <p style="font-size: 0.875rem;">
              3rd Floor, Plot No. - 12/B, Pocket 3, Sector – 17,<br/>
              Dwarka, New Delhi – 110 075<br/>
              Ph.: +91-11-4572 0141 / 4445 8664
            </p>
          </div>
          <p style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 1.1rem; font-weight: bold; color:black;">
            DIGITAL COPY
          </p>
          <div>
            <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" alt="Indigo Infraprojects Pvt. Ltd. logo" width="100" height="50"/>
          </div>
        </div>
        <h2 style="text-align: center; font-size: 1.125rem; font-weight: bold; margin-bottom: 1rem;">MATERIAL TRANSFER NOTE (MTN / CHALLAN)</h2>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem;">
          <div>
            <p>TRANSFER No. <span style="font-weight: bold;">${data?.document?.transferNo || ''}</span></p>
            <p>From Location:<strong> ${data?.document?.items[0]?.from?.toUpperCase() || ''}</strong></p>
            <p>Requested By:<strong> ${data?.document?.user?.name?.toUpperCase() || ''}</strong></p>
          </div>
          <div>
           <p>Date:<strong> ${formatDateDMY(data?.document?.createdAt)}</strong></p>
            <p>To Location:<strong> ${data?.document?.items[0]?.to?.toUpperCase() || ''}</strong></p>
            <p>Status: <strong>${data?.document?.status?.toUpperCase() || ''}</strong></p>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Part No.</th>
              <th>Description</th>
              <th>Required Qty.</th>
              <th>Approved Qty.</th>
              <th>Unit</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            ${data?.document?.items
        .map((item, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${item?.masterItem?.partNo || ''}</td>
                  <td>${item?.masterItem?.description || ''}</td>
                  <td>${item?.transferQty}</td>
                  <td>${item?.approveQty || ''} (${item?.masterItem?.unitName || ''})</td>
                  <td>${item?.masterItem?.unitName || ''}</td>
                  <td>${item?.status || ''}</td>
                </tr>
              `)
        .join('')}
          </tbody>
        </table>
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem; margin-top: 1rem;">
          <div>
            <p>Vehicle No.: ................................................</p>
            <p>Store Incharge: ................................................</p>
            <p>Date: ................................................</p>
          </div>
          <div>
            <p>Received By: <strong>${data?.mtn?.user?.name?.toUpperCase() || ''}</strong></p>
            <p>................................................</p>
            <p>Date: <strong>${formatDateDMY(data?.mtn?.createdAt)}</strong></p>
          </div>
          <div>
            <p>Verified & Accepted By :</p>
            <p>................................................</p>
            <p>Date: ................................................</p>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
    if (requestType === "rv") {
      printWindow.document.write(htmlMRvContent);
    }
    else if (requestType === "repair-mrv") {
      printWindow.document.write(htmlRepairMRVContent);
    }
    else if (requestType === "repair-request") {
      // ✅ REPAIR REQUEST PRINT
      printWindow.document.write(
        htmlRepairRequestContent
      )
    }
    else if (requestType === "transfer") {
      printWindow.document.write(htmlContent);
    }
    else if (requestType === "miv") {
      printWindow.document.write(htmlContentForMIV);
    }
    else if (requestType === "transferrequest") {
      printWindow.document.write(htmlTRanferRequestContent);
    }
    else if (requestType === "requisition") {
      printWindow.document.write(htmlRequisitionContent);
    }
    else {
      printWindow.document.write(htmlContent);
    }

    printWindow.document.close();
    printWindow.print();


  };

  return (
    <div className="col-xl-12">
      {/* Filter Section */}
      <div className="filter cm-content-box box-primary">
        <div className="content-title">
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link
              to={"#"}
              className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
              onClick={() => setOpen(!open)}
            >
              <i className={`fas ${open ? "fa-angle-down" : "fa-angle-up"}`}></i>
            </Link>
          </div>
        </div>
        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-3 col-xxl-3">
                  <label className="ms-2">Enter Form Number</label>
                  <input
                    type="text"
                    placeholder="Enter Form Number"
                    className="form-control mb-xxl-0 mb-3"
                    value={formNumber}
                    onChange={(e) => setFormNumber(e.target.value)}
                  />
                </div>

                <div className="col-xl-3 col-xxl-3">
                  <label className="ms-2">Select Request Type</label>
                  <select
                    className="form-select"
                    style={{ height: "55px" }}
                    value={requestType}
                    onChange={(e) => setRequestType(e.target.value)}
                  >
                    <option value="requisition">Requisition Request</option>
                    <option value="rv">Requisition Voucher(MRV)</option>
                    <option value="miv">Material Issue Voucher(MIV)</option>
                    <option value="transferrequest">Transfer Request</option>
                    <option value="transfer">Transfer Voucher(MTN)</option>
                    <option value="repair-request">Repair Request</option>
                    <option value="repair-mrv">Repair Receive Voucher(RRV)</option> {/* ✅ NEW */}
                  </select>
                </div>

                <div className="col-xl-3 col-xxl-3">
                  <label className="ms-2">Store</label>
                  <select
                    className="form-select mb-xl-0 mb-3 pt-3 pb-3"
                    value={selectedStore}
                    onChange={handleStoreChange}
                  >
                    {stores.map((store) => (
                      <option key={store._id} value={store._id}>
                        {`${store.name}, ${store.location}`}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-xl-3 col-xxl-3">
                  <label className="ms-2">Search</label>
                  <button
                    className="form-control btn btn-primary"
                    onClick={handleSearch}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Search"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>

      {/* Dynamic Table Rendering */}
      {requestType === "transfer" && (
        <TransferTable data={data} reportData={reportData} totalcount={reportData.length} handlePrint={handlePrint} />
      )}
      {requestType === "rv" && (
        <RVTable reportData={reportData} totalcount={reportData.length} handlePrint={handlePrint} data={data} />
      )}
      {requestType === "miv" && (
        <MIVTable data={data} reportData={reportData} totalcount={reportData.length} handlePrint={handlePrint} />
      )}
      {requestType === "transferrequest" && (
        <TransferRequestTable data={data} reportData={reportData} totalcount={reportData.length} handlePrint={handlePrint} />
      )}
      {requestType === "repair-mrv" && (
        <RepairMRVTable
          reportData={reportData}
          totalcount={reportData.length}
          handlePrint={handlePrint}
          data={data}
        />
      )}
      {requestType === "requisition" && (
        <RequisitionTable
          data={data}
          reportData={reportData}
          totalcount={reportData.length}
          handlePrint={handlePrint}
        />
      )}

      {requestType === "repair-request" && (
        <RepairRequestTable
          data={data}
          reportData={data?.document?.items || []}
          totalcount={
            data?.document?.itemCount ||
            data?.document?.items?.length ||
            0
          }
          handlePrint={handlePrint}
        />
      )}
    </div>
  );



};

export default GenrateDigitalForm;
